module.exports = __webpack_public_path__ + "static/floral-cdaf6850a6932c2e976e1ded7e0ccf94.png";